import { ENV_COUNTRY } from "../../components/Commons/Hooks/Variables/Enviroment";

const COUNTRY_MAP = {
	CL: 'Chile',
	CLNARMA: 'Chile',
	MX: 'México',
	AR: 'Argentina',
};


const envCountryCode = ENV_COUNTRY || 'CL';

export const CURRENT_COUNTRY = COUNTRY_MAP[envCountryCode] || 'Chile';
